export const DEFAULT_AVATAR = '/profile-img/default-user-profile.svg';
export const DEFAULT_IMAGE = '/images/default-petition-darker.gif';
export const DEFAULT_IMAGE_LIGHT = '/images/default-petition.gif';
